module.exports = __webpack_public_path__ + "Roboto-BoldItalic.4b2cc52b05e2a960c4f1.eot";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-BoldItalic.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BoldItalic.eot
// module chunks = styles